import { Box, Container, Grid } from "@mui/material";
import { Outlet } from "react-router-dom";

//general components
import Header from "../../components/common/header/header";
import AdminPanelMenu from "../../components/view/admin-panel/admin-panel-menu/admin-panel-menu";

function AdminPanel() {
    return (
        <Box className="user-panel">
            {/* <Grid container item xs={12} display={{ xs: 'none', md: 'flex' }}> <Header></Header></Grid> */}
            <Container maxWidth='xl'>
                <Grid container columnGap={3} justifyContent='space-between' alignItems='flex-start' display={{ xs: 'none', md: 'flex' }}>
                    <Grid container item xs={12} md={2}><AdminPanelMenu></AdminPanelMenu></Grid>

                    <Grid container item xs={12} md={9.5}><Outlet /></Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default AdminPanel;